import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import DocumentHeader from 'Components/DocumentHeader';
import DocumentWrapper from 'Components/DocumentWrapper';
import HistorySection from 'Components/HistorySection';
import FormEditingHandler from 'Containers/FormEditingHandler';

import VNSForm from './Form';
import { findActive, findEnded } from '../utils';
import HistoryRowData from './HistoryRowData';
import DocumentCreationButton from '../../../components/DocumentCreationButton';
import type { DocTypesByPageName } from '../../../config/platformSettings';

const History = ({ documents, startEdit, setAnchor }: IHistory): React.JSX.Element => {
  return (
    <React.Fragment>
      {findActive(documents).length > 0 && (
        <HistorySection headerText={<FormattedMessage id="vns.vnsActive" />} hasHistoryRows={true}>
          {findActive(documents).map((d, i) => (
            <div key={'vns' + i}>
              <HistoryRowData d={d} startEdit={startEdit} setAnchor={setAnchor} />
            </div>
          ))}
        </HistorySection>
      )}
      {findEnded(documents).length > 0 && (
        <HistorySection headerText={<FormattedMessage id="vns.vnsEnded" />} inactive={true} hasHistoryRows={true}>
          {findEnded(documents).map((d, i) => (
            <div key={'vns' + i}>
              <HistoryRowData d={d} startEdit={startEdit} setAnchor={setAnchor} />
            </div>
          ))}
        </HistorySection>
      )}
    </React.Fragment>
  );
};

interface IHistory {
  documents: IDocumentWithTypeV2<'vns'>[];
  startEdit: StartEdit;
  setAnchor: (anchor?: string) => () => void;
}

const VNS = ({ documents }: IOwnProps): React.JSX.Element => {
  // Anchor for scrolling to specific form sections in form
  const [anchor, setAnchor] = React.useState<string | undefined>(undefined);
  const setAnchorValue = (anchor?: string) => (): void => {
    setAnchor(anchor);
  };

  return (
    <FormEditingHandler name="vns" documents={documents}>
      {(editing, startEdit, formData): React.JSX.Element => (
        <DocumentWrapper>
          <DocumentHeader
            name={'vns'}
            headerId={'vns.title'}
            editing={editing}
            editButtons={
              documents.length > 0 && findEnded(documents).length < documents.length ? (
                <div>&nbsp;</div>
              ) : (
                <div>
                  <DocumentCreationButton name="vns" text={'general.new'} onClick={startEdit({})} />
                </div>
              )
            }
          />
          {editing ? <VNSForm editing={editing} formData={formData} anchor={anchor} /> : undefined}
          {!editing ? <History documents={documents} startEdit={startEdit} setAnchor={setAnchorValue} /> : undefined}
        </DocumentWrapper>
      )}
    </FormEditingHandler>
  );
};

interface IOwnProps {
  documents: Array<IDocumentWithTypeV2<DocTypesByPageName['vns']>>;
}

export default VNS;
